module.exports = angular.module('cartographer.plugin.layer.priority-habitats', [])

module.exports.run $DI (
  crtLayer
  crtFeatureLayer
  crtAttributeLayer
  crtMapCollaborationModel
  crtMapPermissionModel
  crtMarkerColor
  neNaturalnessClass
  neLakeRestorationPrioritiesPhysicalMeasure
  neLakeRestorationPrioritiesHydrologicalMeasure
  neLakeRestorationPrioritiesChemicalMeasure
  neLakeRestorationPrioritiesBiologicalMeasure
  neRiverRestorationPrioritiesPhysicalMeasure
  neRiverRestorationPrioritiesHydrologicalMeasure
  neRiverRestorationPrioritiesChemicalMeasure
  neRiverRestorationPrioritiesBiologicalMeasure
) ->
  createNaturalnessBucket = (value, color) ->
    ({ value, color, label: neNaturalnessClass.valueName(value) })

  createNaturalnessAttribute = (id, name) ->
    crtAttributeLayer.createThreshold(id, name, null, [
      createNaturalnessBucket(1 , crtMarkerColor.quality(0.9))
      createNaturalnessBucket(2 , crtMarkerColor.quality(0.7))
      createNaturalnessBucket(3 , crtMarkerColor.quality(0.5))
      createNaturalnessBucket(4 , crtMarkerColor.quality(0.3))
      createNaturalnessBucket(5 , crtMarkerColor.quality(0.1))
    ])

  createRestorationPrioritiesAttribute = (id, name) ->
    crtAttributeLayer.createLookup(id, name, null, [
      { value: true,  color: crtMarkerColor.create("#0e0"), label: "Yes" }
      { value: false, color: crtMarkerColor.create("#eee"), label: "No" }
    ])

  neLakeNaturalnessLayer = crtFeatureLayer.create({
    id: "neLakeNaturalness"
    name: "Lake Naturalness"
    atlasMapId: "neLakeNaturalness"
    defaultMapEngine: "atlas"
    selectionRadius: 10
    attributeGroups: [
      crtFeatureLayer.createAttributeGroup("site", "Site Information", [
        crtAttributeLayer.createAutoLookup("lakeName", "Lake Name")
        crtAttributeLayer.createAutoLookup("lakeNameSource", "Source of Lake Name")
        crtAttributeLayer.createAutoLookup("waterbodyId", "Waterbody ID")
      ])
      crtFeatureLayer.createAttributeGroup("naturalness", "Naturalness Classes", [
        createNaturalnessAttribute("physical", "Physical")
        createNaturalnessAttribute("hydrological", "Hydrological")
        createNaturalnessAttribute("chemical", "Chemical")
        createNaturalnessAttribute("biological", "Biological")
      ])
    ]
  })

  neRiverNaturalnessLayer = crtFeatureLayer.create({
    id: "neRiverNaturalness"
    name: "River/Stream Naturalness"
    atlasMapId: "neRiverNaturalness"
    defaultMapEngine: "atlas"
    selectionRadius: 10
    attributeGroups: [
      crtFeatureLayer.createAttributeGroup("site", "Site Information", [
        crtAttributeLayer.createAutoLookup("reachName", "Watercourse Name")
        crtAttributeLayer.createAutoLookup("reachNameSource", "Source of Watercourse Name")
        crtAttributeLayer.createAutoLookup("drnId", "Watercourse ID")
        crtAttributeLayer.createAutoLookup("wfdCatchmentId", "WFD Catchment ID")
        crtAttributeLayer.createAutoLookup("wfdWaterbodyId", "WFD Waterbody ID")
      ])
      crtFeatureLayer.createAttributeGroup("naturalness", "Naturalness Classes", [
        createNaturalnessAttribute("physical", "Physical")
        createNaturalnessAttribute("hydrological", "Hydrological")
        createNaturalnessAttribute("chemical", "Chemical")
        createNaturalnessAttribute("biological", "Biological")
      ])
    ]
  })

  neLakeRestorationPrioritiesLayer = crtFeatureLayer.create({
    id: "neLakeRestorationPriorities"
    name: "Lake Restoration Priorities"
    atlasMapId: "neLakeRestorationPriorities"
    defaultMapEngine: "atlas"
    selectionRadius: 10
    attributeGroups: [
      crtFeatureLayer.createAttributeGroup("site", "Site Information", [
        crtAttributeLayer.createAutoLookup("lakeName", "Lake Name")
        crtAttributeLayer.createAutoLookup("lakeNameSource", "Source of Lake Name")
        crtAttributeLayer.createAutoLookup("waterbodyId", "Waterbody ID")
      ])
      crtFeatureLayer.createAttributeGroup("naturalness", "Restoration Priorities", [
        createRestorationPrioritiesAttribute("physical", "Physical")
        createRestorationPrioritiesAttribute("hydrological", "Hydrological")
        createRestorationPrioritiesAttribute("chemical", "Chemical")
        createRestorationPrioritiesAttribute("biological", "Biological")
      ])
    ]
  })

  neRiverRestorationPrioritiesLayer = crtFeatureLayer.create({
    id: "neRiverRestorationPriorities"
    name: "River/Stream Restoration Priorities"
    atlasMapId: "neRiverRestorationPriorities"
    defaultMapEngine: "atlas"
    selectionRadius: 10
    attributeGroups: [
      crtFeatureLayer.createAttributeGroup("site", "Site Information", [
        crtAttributeLayer.createAutoLookup("reachName", "Watercourse Name")
        crtAttributeLayer.createAutoLookup("reachNameSource", "Source of Watercourse Name")
        crtAttributeLayer.createAutoLookup("drnId", "Watercourse ID")
        crtAttributeLayer.createAutoLookup("wfdCatchmentId", "WFD Catchment ID")
        crtAttributeLayer.createAutoLookup("wfdWaterbodyId", "WFD Waterbody ID")
      ])
      crtFeatureLayer.createAttributeGroup("naturalness", "Restoration Priorities", [
        createRestorationPrioritiesAttribute("physical", "Physical")
        createRestorationPrioritiesAttribute("hydrological", "Hydrological")
        createRestorationPrioritiesAttribute("chemical", "Chemical")
        createRestorationPrioritiesAttribute("biological", "Biological")
      ])
    ]
  })

  # We don't need this any more. The Atlas neRiverRestorationPriorities map handles both layers:
  #
  # neRiverRestorationPriorityAreasLayer = crtFeatureLayer.create({
  #   id: "neRiverRestorationPriorityAreas"
  #   name: "River/Stream Restoration Priorities (Area Based)"
  #   atlasMapId: "neRiverRestorationPriorityAreas"
  #   defaultMapEngine: "atlas"
  #   selectionRadius: 10
  #   attributeGroups: [
  #     crtFeatureLayer.createAttributeGroup("site", "Site Information", [
  #       crtAttributeLayer.createAutoLookup("wfdWaterbodyId", "WFD Waterbody ID")
  #       crtAttributeLayer.createAutoLookup("headwater", "Headwater?")
  #     ])
  #     crtFeatureLayer.createAttributeGroup("naturalness", "Restoration Priorities", [
  #       createRestorationPrioritiesAttribute("physical", "Physical")
  #       createRestorationPrioritiesAttribute("hydrological", "Hydrological")
  #       createRestorationPrioritiesAttribute("chemical", "Chemical")
  #       createRestorationPrioritiesAttribute("biological", "Biological")
  #     ])
  #   ]
  # })

  neChalkRiversLayer = crtFeatureLayer.create({
    id: "neChalkRivers"
    name: "Mapping Chalk Rivers/Streams"
    atlasMapId: "neChalkRivers"
    defaultMapEngine: "atlas"
    selectionRadius: 10
    attributeGroups: [
      crtFeatureLayer.createAttributeGroup("site", "Site Information", [
        crtAttributeLayer.createAutoLookup("reachName", "Watercourse Name")
        crtAttributeLayer.createAutoLookup("reachNameSource", "Source of Watercourse Name")
        crtAttributeLayer.createAutoLookup("drnId", "Watercourse ID")
        crtAttributeLayer.createAutoLookup("wfdCatchmentId", "WFD Catchment ID")
        crtAttributeLayer.createAutoLookup("wfdWaterbodyId", "WFD Waterbody ID")
      ])
      crtFeatureLayer.createAttributeGroup("modification", "Map Modifications", [
        crtAttributeLayer.createLookup("modification", "Modification Type", null, [
          { value: "Addition", label: "Addition", color: crtMarkerColor.create("lime") }
          { value: "Deletion", label: "Deletion", color: crtMarkerColor.create("orange") }
        ])
      ])
    ]
  })

  neRiverTypesLayer = crtFeatureLayer.create({
    id: "neRiverTypes"
    name: "Mapping River/Stream Types"
    atlasMapId: "neRiverTypes"
    defaultMapEngine: "atlas"
    selectionRadius: 10
    attributeGroups: []
  })

  crtLayer.registerPlugin(neChalkRiversLayer)
  crtLayer.registerPlugin(neLakeNaturalnessLayer)
  crtLayer.registerPlugin(neRiverNaturalnessLayer)
  crtLayer.registerPlugin(neLakeRestorationPrioritiesLayer)
  crtLayer.registerPlugin(neRiverRestorationPrioritiesLayer)
  # crtLayer.registerPlugin(neRiverRestorationPriorityAreasLayer)
  crtLayer.registerPlugin(neRiverTypesLayer)

  return
